type ParticipationView = {
  phase: string;
  isAdmin: boolean;
  isDisplay: boolean;
  isSpectator?: boolean;
  spectators?: Array<{ name: string; connected: boolean }>;
};

export function hostParticipationHtml(room: ParticipationView, escapeHtml: (value: string) => string) {
  if (room.isDisplay) return "";
  if (room.phase === "lobby" && room.isAdmin) return `
    <section class="host-participation glass-card">
      <label for="admin-sit-out"><input id="admin-sit-out" type="checkbox" ${room.isSpectator ? "checked" : ""}>
        <span><strong>Sit out this game</strong><small>Start the game for everyone else and watch. Uncheck this in the next lobby to play again.</small></span>
      </label>
    </section>`;
  if (room.isSpectator) return `<aside class="host-participation host-participation--watching" role="status"><strong>You’re sitting out this game</strong><span>You can watch and use the room’s admin controls.</span></aside>`;
  const host = room.spectators?.[0];
  return host ? `<aside class="host-participation host-participation--watching"><strong>${escapeHtml(host.name)} is sitting out</strong><span>Room admin · ${host.connected ? "watching this game" : "disconnected"}</span></aside>` : "";
}

export function spectatorRoundControl(phase: string): { type: string; label: string } | null {
  const controls: Record<string, { type: string; label: string }> = {
    poker_result: { type: "poker_next_hand", label: "Deal next hand" },
    blackjack_result: { type: "blackjack_next_round", label: "Next blackjack round" },
    hearts_round_result: { type: "hearts_next_round", label: "Next Hearts round" },
    spades_round_result: { type: "spades_next_round", label: "Next Spades round" },
    uno_round_result: { type: "uno_next_round", label: "Next UNO round" },
  };
  return controls[phase] || null;
}
